import React, { useState, useEffect } from 'react';
import '../index.css';

const Blog = () => {
  const generatePlaceholderImage = (text) => {
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='600'%3E%3Crect fill='%23f0f2f5' width='800' height='600'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='24' fill='%23999' text-anchor='middle' dy='.3em'%3E${encodeURIComponent(text)}%3C/text%3E%3C/svg%3E`;
  };

  // Blog Articles Data - Sorted by date (newest first)
  const blogArticles = [
    // REAL Articles - NEWEST FIRST
    {
      id: 'real-1',
      title: 'Logistik Personal finden: Social Recruiting Strategien für die Logistikbranche',
      excerpt: 'In Zeiten des akuten Fachkräftemangels stellt die Suche nach qualifiziertem Logistikpersonal Unternehmen vor große Herausforderungen. Besonders in Logistik-Hotspots wie Berlin zeigen Social Recruiting Strategien beeindruckende Erfolge.',
      image: '/images/blog/logistik-personal-finden.jpg',
      category: 'Case Studies',
      date: '2025-11-27',
      readTime: '9 Min.',
      wordCount: '2900',
      url: '/blog/logistik-personal-finden.html'
    },
    {
      id: 'real-2',
      title: 'Personalgewinnung in der Pflege: Innovative Wege über Social Media',
      excerpt: 'Die Personalgewinnung in der Pflege stellt eine der größten Herausforderungen für das deutsche Gesundheitssystem dar. Besonders in Metropolen wie Berlin kämpfen Pflegeeinrichtungen mit akutem Personalmangel.',
      image: '/images/blog/personalgewinnung-in-der-pflege.jpg',
      category: 'Case Studies',
      date: '2025-11-26',
      readTime: '10 Min.',
      wordCount: '3100',
      url: '/blog/personalgewinnung-in-der-pflege.html'
    },
    {
      id: 'real-3',
      title: 'Social Recruiting Trends 2025: Der ultimative Guide für Berliner Unternehmen',
      excerpt: 'Die Social Recruiting Landschaft verändert sich rasant. In unserem umfassenden Guide erfahren Sie, welche Trends 2025 in Berlin dominieren werden und wie Sie diese für Ihr Unternehmen nutzen können.',
      image: '/images/blog/social-recruiting-trends-2025.jpg',
      category: 'Trends',
      date: '2025-01-15',
      readTime: '8 Min.',
      wordCount: '2500',
      url: '/blog/social-recruiting-trends-2025-berlin.html'
    },
    {
      id: 'real-4',
      title: 'Instagram Recruiting Berlin: Case Study Vattenfall – 150% mehr Bewerbungen',
      excerpt: 'Wie Vattenfall durch strategisches Instagram Recruiting seine Bewerberzahlen in Berlin um 150% steigern konnte. Detaillierte Analyse der Kampagne, Kosten und Ergebnisse.',
      image: '/images/blog/instagram-recruiting-berlin.jpg',
      category: 'Instagram',
      date: '2025-01-10',
      readTime: '6 Min.',
      wordCount: '1800',
      url: '/blog/instagram-recruiting-berlin-case-study.html'
    },
    {
      id: 'real-5',
      title: 'TikTok Recruiting: Wie Berliner Start-ups Gen Z erfolgreich erreichen',
      excerpt: 'TikTok ist mehr als nur Tanzvideos. Erfahren Sie, wie Berliner Start-ups die Plattform nutzen, um junge Talente zu gewinnen. Mit praktischen Tipps und erfolgreichen Beispielen.',
      image: '/images/blog/tiktok-recruiting-genz.jpg',
      category: 'TikTok',
      date: '2025-01-08',
      readTime: '7 Min.',
      wordCount: '2100',
      url: '/blog/tiktok-recruiting-genz-berlin.html'
    },
    {
      id: 'real-6',
      title: 'LinkedIn Recruiting Berlin: B2B-Strategien für die Hauptstadt',
      excerpt: 'Professionelle B2B-Recruiting-Strategien für LinkedIn in Berlin. Von Executive Search bis zur Optimierung Ihres Unternehmensprofils – der komplette Guide für B2B-Unternehmen.',
      image: '/images/blog/linkedin-recruiting-b2b.jpg',
      category: 'LinkedIn',
      date: '2025-01-05',
      readTime: '9 Min.',
      wordCount: '2800',
      url: '/blog/linkedin-recruiting-b2b-berlin.html'
    },
    {
      id: 'real-7',
      title: 'Fachkräftemangel Berlin: Wie Social Recruiting die Lösung ist',
      excerpt: 'Der Fachkräftemangel in Berlin spitzt sich zu. Social Recruiting bietet neue Wege, qualifizierte Mitarbeiter zu finden. Daten, Fakten und praktische Lösungsansätze.',
      image: '/images/blog/fachkraeftemangel-berlin.jpg',
      category: 'Trends',
      date: '2025-01-03',
      readTime: '10 Min.',
      wordCount: '3200',
      url: '/blog/fachkraeftemangel-berlin-social-recruiting.html'
    },
    {
      id: 'real-8',
      title: 'Employee Advocacy Berlin: Mitarbeiter als Markenbotschafter',
      excerpt: 'Employee Advocacy Programme machen Mitarbeiter zu authentischen Markenbotschaftern. Erfahren Sie, wie Berliner Unternehmen ihre Mitarbeiter erfolgreich in den Recruiting-Prozess einbinden.',
      image: '/images/blog/employer-branding-social-media.jpg',
      category: 'Trends',
      date: '2024-12-28',
      readTime: '7 Min.',
      wordCount: '2200',
      url: '/blog/employee-advocacy-berlin-mitarbeiter-botschafter.html'
    },
    // Demo Articles with author info
    {
      id: 'dummy-100',
      title: 'Social Media Recruiting Trends 2025: Was Berliner Startups jetzt wissen müssen',
      excerpt: 'Die Recruiting-Landschaft ändert sich rasant. Erfahren Sie, welche Social Media Trends 2025 für Berliner Startups besonders wichtig werden und wie Sie diese für Ihre Talentsuche nutzen können.',
      image: generatePlaceholderImage('Social Recruiting Trends'),
      category: 'Trends',
      date: '2025-01-20',
      readTime: '9 Min.',
      wordCount: '2800',
      author: 'Max Mustermann',
      authorImage: generatePlaceholderImage('MM'),
      url: '/blog/social-recruiting-trends-2025-berlin'
    },
    {
      id: 'dummy-101',
      title: 'Instagram Recruiting für IT-Unternehmen in Berlin: Praxis-Guide 2025',
      excerpt: 'Wie IT- und Tech-Unternehmen in Berlin Instagram erfolgreich für ihr Recruiting nutzen. Mit konkreten Beispielen, Kampagnen-Strukturen und Performance-Benchmarks aus der Praxis.',
      image: generatePlaceholderImage('Instagram Recruiting'),
      category: 'Instagram',
      date: '2025-01-18',
      readTime: '12 Min.',
      wordCount: '3500',
      author: 'Anna Schmidt',
      authorImage: generatePlaceholderImage('AS'),
      url: '#'
    },
    {
      id: 'dummy-102',
      title: 'LinkedIn vs. Instagram Recruiting: Welche Plattform für welche Zielgruppe in Berlin?',
      excerpt: 'Ein detaillierter Vergleich der beiden wichtigsten Recruiting-Plattformen für Berliner Unternehmen. Kosten, Reichweite, Zielgruppen und Erfolgsfaktoren im direkten Vergleich.',
      image: generatePlaceholderImage('LinkedIn vs Instagram'),
      category: 'LinkedIn',
      date: '2025-01-16',
      readTime: '10 Min.',
      wordCount: '3100',
      author: 'Thomas Weber',
      authorImage: generatePlaceholderImage('TW'),
      url: '#'
    },
    ...Array.from({length: 40}, (_, i) => ({
      id: `dummy-${111 + i}`,
      title: `${['Social Media', 'Instagram', 'LinkedIn', 'TikTok'][i % 4]} Recruiting Artikel ${111 + i}: ${['Trends', 'Best Practices', 'Case Study', 'Guide'][i % 4]} für Berlin`,
      excerpt: `Entdecken Sie die neuesten ${['Strategien', 'Methoden', 'Ansätze', 'Techniken'][i % 4]} für erfolgreiches Recruiting über ${['Social Media', 'Instagram', 'LinkedIn', 'TikTok'][i % 4]} in Berlin. Mit praktischen Beispielen und umsetzbaren Tipps.`,
      image: generatePlaceholderImage(`Artikel ${111 + i}`),
      category: ['Instagram', 'LinkedIn', 'TikTok', 'Trends'][i % 4],
      date: new Date(2025, 0, 5 - Math.floor(i/4)).toISOString().split('T')[0],
      readTime: `${5 + (i % 8)} Min.`,
      wordCount: `${1500 + (i % 10) * 200}`,
      author: ['Emma Müller', 'Markus Berg', 'Sophie Braun', 'Paul Schmidt', 'Laura Weber', 'Felix Klein'][i % 6],
      authorImage: generatePlaceholderImage(['EM', 'MB', 'SB', 'PS', 'LW', 'FK'][i % 6]),
      url: '#'
    })),
    {
      id: 1,
      title: 'Social Recruiting Trends 2025: Der ultimative Guide für Berliner Unternehmen',
      excerpt: 'Die Social Recruiting Landschaft verändert sich rasant. In unserem umfassenden Guide erfahren Sie, welche Trends 2025 in Berlin dominieren werden und wie Sie diese für Ihr Unternehmen nutzen können.',
      image: generatePlaceholderImage('Social Recruiting Guide'),
      category: 'Trends',
      date: '2025-01-15',
      readTime: '8 Min.',
      wordCount: '2500',
      url: '/blog/social-recruiting-trends-2025-berlin'
    },
    {
      id: 2,
      title: 'Instagram Recruiting Berlin: Case Study Vattenfall – 150% mehr Bewerbungen',
      excerpt: 'Wie Vattenfall durch strategisches Instagram Recruiting seine Bewerberzahlen in Berlin um 150% steigern konnte. Detaillierte Analyse der Kampagne, Kosten und Ergebnisse.',
      image: generatePlaceholderImage('Instagram Case Study'),
      category: 'Instagram',
      date: '2025-01-10',
      readTime: '6 Min.',
      wordCount: '1800',
      url: '/blog/instagram-recruiting-berlin-case-study'
    },
    {
      id: 3,
      title: 'TikTok Recruiting: Wie Berliner Start-ups Gen Z erfolgreich erreichen',
      excerpt: 'TikTok ist mehr als nur Tanzvideos. Erfahren Sie, wie Berliner Start-ups die Plattform nutzen, um junge Talente zu gewinnen. Mit praktischen Tipps und erfolgreichen Beispielen.',
      image: generatePlaceholderImage('TikTok Recruiting'),
      category: 'TikTok',
      date: '2025-01-08',
      readTime: '7 Min.',
      wordCount: '2100',
      url: '/blog/tiktok-recruiting-genz-berlin'
    }
  ];

  const ITEMS_PER_PAGE = 48;
  const articlesWithImages = blogArticles.filter(
    (article) => article.image && article.image.startsWith('/')
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentFilter, setCurrentFilter] = useState('all');
  const [filteredArticles, setFilteredArticles] = useState(articlesWithImages);

  // Format date function
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('de-DE', options);
  };

  // Filter articles effect
  useEffect(() => {
    const filtered = articlesWithImages.filter(article => {
      const matchesSearch = searchTerm === '' || 
        article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.category.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesFilter = currentFilter === 'all' || 
        article.category.toLowerCase().includes(currentFilter.toLowerCase());

      return matchesSearch && matchesFilter;
    });

    setFilteredArticles(filtered);
    setCurrentPage(1);
  }, [searchTerm, currentFilter]);

  // Pagination calculations
  const totalPages = Math.ceil(filteredArticles.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const articlesToShow = filteredArticles.slice(startIndex, endIndex);

  return (
    <>
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                Social Recruiting <span className="hero__highlight">Blog Berlin</span>
              </h1>
              <p className="hero__subtitle">
                Aktuelle Trends, Expertentipps und Case Studies für erfolgreiche
                Mitarbeitergewinnung über Social Media in Berlin und Brandenburg.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="blog-search">
        <div className="container">
          <div className="search-wrapper">
            <div className="search-box">
              <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              <input 
                type="text" 
                className="search-input" 
                placeholder="Artikel durchsuchen... (z.B. Instagram, LinkedIn, TikTok, Berlin)" 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-label="Blog durchsuchen"
              />
            </div>
            <div className="filter-buttons" role="group" aria-label="Artikel-Filter">
              {['all', 'instagram', 'linkedin', 'tiktok', 'trends', 'case'].map((filter) => (
                <button 
                  key={filter}
                  className={`filter-btn ${currentFilter === filter ? 'active' : ''}`}
                  onClick={() => setCurrentFilter(filter)}
                  data-category={filter}
                >
                  {filter === 'all' ? 'Alle Artikel' : 
                   filter === 'case' ? 'Case Studies' :
                   filter.charAt(0).toUpperCase() + filter.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="blog-posts">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Neueste Artikel</h2>
            <p className="section-subtitle">
              Aktuelle Insights, Trends und praktische Tipps für Social Recruiting in Berlin
            </p>
            {(searchTerm || currentFilter !== 'all') && (
              <div className="search-results-info">
                <p className="results-count">{filteredArticles.length} Artikel gefunden</p>
              </div>
            )}
          </div>

          {/* Blog Grid */}
          {articlesToShow.length > 0 ? (
            <div className="blog-grid" role="list">
              {articlesToShow.map((article) => (
                <article key={article.id} className="blog-card" role="listitem">
                  <div className="blog-card__image">
                    <img 
                      src={article.image} 
                      alt={article.title} 
                      loading="lazy"
                    />
                  </div>
                  <div className="blog-card__content">
                    <div className="blog-card__meta">
                      <span className="post-category">{article.category}</span>
                      <time className="post-date" dateTime={article.date}>
                        {formatDate(article.date)}
                      </time>
                    </div>
                    <h3 className="blog-card__title">
                      <a href={article.url}>
                        {article.title}
                      </a>
                    </h3>
                    <p className="blog-card__excerpt">
                      {article.excerpt}
                    </p>
                    {article.author && (
                      <div className="blog-card__author" style={{
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '0.75rem', 
                        margin: '1rem 0', 
                        paddingTop: '1rem', 
                        borderTop: '1px solid #f3f4f6'
                      }}>
                        {article.authorImage && (
                          <img 
                            src={article.authorImage} 
                            alt={article.author} 
                            style={{
                              width: '36px', 
                              height: '36px', 
                              borderRadius: '50%', 
                              objectFit: 'cover'
                            }}
                          />
                        )}
                        <span style={{
                          color: '#6b7280', 
                          fontSize: '0.875rem', 
                          fontWeight: '500'
                        }}>
                          von {article.author}
                        </span>
                      </div>
                    )}
                    <div className="blog-card__stats">
                      <span className="read-time">📖 {article.readTime}</span>
                      <span className="word-count">📝 {article.wordCount}</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>Keine Artikel gefunden. Bitte versuchen Sie eine andere Suchanfrage.</p>
            </div>
          )}

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <nav className="pagination" aria-label="Blog-Seitennavigation">
              <div className="pagination__container">
                <button 
                  className="pagination__btn pagination__btn--prev" 
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  aria-label="Vorherige Seite"
                >
                  <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                  Zurück
                </button>
                
                <div className="pagination__pages">
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i + 1}
                      className={`pagination__number ${currentPage === i + 1 ? 'active' : ''}`}
                      onClick={() => setCurrentPage(i + 1)}
                      aria-label={`Seite ${i + 1}`}
                      aria-current={currentPage === i + 1 ? 'page' : undefined}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
                
                <button 
                  className="pagination__btn pagination__btn--next"
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  aria-label="Nächste Seite"
                >
                  Weiter
                  <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
              <div className="pagination__info">
                Zeige {startIndex + 1}-{Math.min(endIndex, filteredArticles.length)} von {filteredArticles.length} Artikeln
              </div>
            </nav>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Möchten Sie Social Recruiting für Ihr Berliner Unternehmen?</h2>
            <p className="cta-subtitle">
              Vereinbaren Sie jetzt eine kostenlose Social Recruiting Analyse und erfahren Sie,
              welche Strategie für Ihr Unternehmen optimal ist.
            </p>
            <div className="cta-buttons">
              <button 
                className="btn btn--primary btn--large" 
                data-open-consultation 
                data-source="Blog CTA Section"
              >
                Kostenloses Erstgespräch
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
